import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=0afcba74&scoped=true&"
var script = {}
import style0 from "./Buttons.vue?vue&type=style&index=0&id=0afcba74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afcba74",
  null
  
)

export default component.exports